import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=20b0b120&scoped=true&"
import script from "./Avatar.vue?vue&type=script&lang=js&"
export * from "./Avatar.vue?vue&type=script&lang=js&"
import style0 from "./avatar.scss?vue&type=style&index=0&id=20b0b120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b0b120",
  null
  
)

export default component.exports